import React, { useState } from 'react';
import { Loading, TestVideo, VideoContainer } from './loadingStyles';

type VideoProps = {
	src: string;
};

const LoadingVideo: React.FC<VideoProps> = ({ src }) => {
	const [loading, setLoading] = useState(true);
	const [showImages, setShowImages] = useState(false);

	const onComplete = () => {
		setLoading(false);
		// console.log(loading);
		// console.log(`loaded ${src}`);
	};
	return (
		<VideoContainer>
			{/* {loading && <Loading />} */}
			<Loading $loading={loading} />
			<TestVideo controls onLoadedData={onComplete} $loading={loading}>
				<source src={src}></source>
			</TestVideo>
		</VideoContainer>
	);
};

export default LoadingVideo;
